import { render, staticRenderFns } from "./LandownersTable.vue?vue&type=template&id=6ec0e096"
import script from "./LandownersTable.vue?vue&type=script&lang=js"
export * from "./LandownersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports